import React from 'react';
import { Link } from 'react-router-dom';
import { Button, ButtonToolbar, Content, Icon, Panel } from 'rsuite';
import { modifyAccess } from '../../../../helpers/permission';
import * as PERMISSIONS from '../../../../constants/permissions/reservation';
import PageHeader from '../../../../components/PageHeader';
import AccessControl from '../../../../components/AccessControl';
import AccessDenied from '../../../../components/AccessDenied';
import PageLayout from '../../../../components/reservations/PageLayout';
import { reservationsROPicklistCreatePath } from '../../../Paths';
import ROPicklistSearch from '../../../../containers/reservations/ROPicklistSearch';
import ROPicklistList from '../../../../containers/reservations/ROPicklistList';

export default () => (
  <PageLayout>
    <AccessControl
      allowOnlyFor={modifyAccess(PERMISSIONS.RO_PICKLIST)}
      fallback={<AccessDenied />}
    >
      <PageHeader title="Pick Lists">
        <Panel bordered>
          <ButtonToolbar style={{ float: 'right' }}>
            <AccessControl allowOnlyFor={modifyAccess(PERMISSIONS.RO_PICKLIST)}>
              <Link to={reservationsROPicklistCreatePath}>
                <Button appearance="primary">
                  <Icon icon="plus-circle" /> Create New
                </Button>
              </Link>
            </AccessControl>
          </ButtonToolbar>
          <ROPicklistSearch placeholder="Search Name or Description" />
        </Panel>
      </PageHeader>
      <Content>
        <ROPicklistList />
      </Content>
    </AccessControl>
  </PageLayout>
);
